import { State as ApiKeysState } from './reducer';
import { ApiKey } from './types';

type State = {
  settings: {
    apiKeys: ApiKeysState;
  };
};

export const getApiKeys = (state: State) => state.settings.apiKeys;

export const isFetchingApiKeys = (state: State) => state.settings.apiKeys.isFetching;

export const createApiKeySelector = (keyIdentifier: string) => (state: State) => {
  const { keys = [] } = getApiKeys(state);
  return keys.find((apiKey) => apiKey.keyIdentifier === keyIdentifier) || ({} as ApiKey);
};
